import { render } from "./Consumed.vue?vue&type=template&id=332a7091&scoped=true"
import script from "./Consumed.vue?vue&type=script&lang=js"
export * from "./Consumed.vue?vue&type=script&lang=js"

import "./Consumed.vue?vue&type=style&index=0&id=332a7091&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-332a7091"

export default script